function formatZipCode(input) {
    let value = input.value.replace(/\D/g, '');
    if (value.length > 5) {
        value = value.slice(0, 5) + '-' + value.slice(5, 8);
    }
    input.value = value;
}

function initCartCalculate() {
    // Use event delegation for the zip code input
    document.addEventListener('input', function(e) {
        if (e.target && e.target.id === 'zip_code_cart') {
            formatZipCode(e.target);
        }
    });

    // Use event delegation for the calculate button
    document.addEventListener('click', function(e) {
        const btnShippingCart = e.target.closest('#btn_shipping_cart');
        if (!btnShippingCart) return;

        const zipCodeInput = document.getElementById('zip_code_cart');
        const shippingResult = document.getElementById('shipping_result_cart');
        if (!zipCodeInput || !shippingResult) return;

        let zipCode = zipCodeInput.value;
        zipCode = zipCode.replace(/\D/g, '');

        if (zipCode.length === 8) {
            zipCode = zipCode.slice(0, 5) + '-' + zipCode.slice(5);
        } else {
            shippingResult.innerHTML = 'CEP inválido. Certifique-se de inserir 8 dígitos.';
            return;
        }

        const span = btnShippingCart.querySelector('span');
        const img = btnShippingCart.querySelector('.loading');
        if (span) span.innerText = '';
        if (img) img.style.display = 'block';
        btnShippingCart.style.opacity = '.7';
        btnShippingCart.style.pointerEvents = 'none';

        let province = '';
        fetch(`https://viacep.com.br/ws/${zipCode.replace('-', '')}/json/`)
            .then(response => response.json())
            .then(data => {
                if (data.uf) {
                    province = data.uf;
                } else {
                    throw new Error('Não foi possível determinar o estado para o CEP fornecido.');
                }

                return fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zipCode}&shipping_address[country]=BR&shipping_address[province]=${province}`);
            })
            .then(shippingResponse => shippingResponse.json())
            .then(shippingData => {
                if (shippingData.shipping_rates && shippingData.shipping_rates.length > 0) {
                    const shippingOptions = shippingData.shipping_rates
                        .map(rate => `<b>${rate.name}</b>` + " - " + (rate.delivery_days[0] ? rate.delivery_days[0] + (rate.delivery_days[0] > 1? " dias" : " dia")  : "24h") + (rate.price == "0.00" ? " - Grátis" : " - R$ " + rate.price.replaceAll('.', ',')))
                        .join('<br>');
                    shippingResult.innerHTML = shippingOptions;
                } else {
                    shippingResult.innerHTML = 'Nenhuma opção de frete disponível para este CEP.';
                }

                if (span) span.innerText = 'Calcular';
                if (img) img.style.display = 'none';
                btnShippingCart.style.opacity = '1';
                btnShippingCart.style.pointerEvents = 'initial';
            })
            .catch(error => {
                shippingResult.innerHTML = 'Erro ao obter opções de frete. Verifique o console.';
                console.error('Erro:', error);
                
                if (span) span.innerText = 'Calcular';
                if (img) img.style.display = 'none';
                btnShippingCart.style.opacity = '1';
                btnShippingCart.style.pointerEvents = 'initial';
            });
    });
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initCartCalculate);

// Re-initialize when cart drawer content changes with debounce protection
let isProcessing = false;

document.addEventListener('cart:updated', () => {
  if (isProcessing) {
    return;
  }
  isProcessing = true;
  
  initCartCalculate();
  
  setTimeout(() => {
    isProcessing = false;
  }, 500);
});